import { ButtonContainer, IDataTableColumn } from "nsitools-react";

import * as React from "react";
import { useHistory } from "react-router";

import {
  EBooleanSearchTypes,
  TitreDiplomeCertificationApi,
  TitreDiplomeCertificationGridDto,
  TitreDiplomeCertificationSearchDto
} from "../../../../../api";
import { ERoutes } from "../../../../../AppRouter";
import { BooleanColumn, EditButton, SearchTablePage, ViewButton } from "../../../../../components";
import { useAbortableApiServiceFactory, useApiService, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";

interface ITitreDiplomeCertificationListPageProps {}

export const TitreDiplomeCertificationListPage: React.FunctionComponent<ITitreDiplomeCertificationListPageProps> = () => {
  const { t } = useTl();
  const history = useHistory();
  const api = useApiService(TitreDiplomeCertificationApi);
  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: TitreDiplomeCertificationGridDto) => (
          <ButtonContainer>
            <ViewButton
              minimal={true}
              onClick={() =>
                history.push(`${ERoutes.titreDiplomeCertification}/${row.idtitreDiplomeCertification}/detail/view`)
              }
            />
            <EditButton
              minimal={true}
              onClick={() =>
                history.push(`${ERoutes.titreDiplomeCertification}/${row.idtitreDiplomeCertification}/detail/edit`)
              }
            />
          </ButtonContainer>
        )
      },
      {
        header: () => t(ETLCodes.Libelle),
        fieldName: "description"
      },
      {
        header: () => t(ETLCodes.Actif),
        fieldName: "actif",
        alignment: "center",
        render: (row: TitreDiplomeCertificationGridDto) => <BooleanColumn value={row.actif} />
      }
    ],
    [history, t]
  );

  const onAddItem = React.useCallback(() => {
    history.push(`${ERoutes.diplome}/0/detail/edit`);
  }, [history]);

  const getCriteriasFn = React.useCallback(
    () => api.titreDiplomeCertificationGetSearchCriterias({ includeListsValues: true }),
    [api]
  );

  const apiFactory = useAbortableApiServiceFactory(TitreDiplomeCertificationApi);
  const lastAbortController = React.useRef<AbortController>();
  const searchFn = React.useCallback(
    (sObj?: TitreDiplomeCertificationSearchDto) => {
      const { api: abortableApi, abortController } = apiFactory();
      lastAbortController.current = abortController;
      return abortableApi.titreDiplomeCertificationBaseSearch({ TitreDiplomeCertificationSearchDto: sObj });
    },
    [apiFactory]
  );

  const onAbort = React.useCallback(() => lastAbortController.current?.abort(), []);

  return (
    <SearchTablePage
      getCriteriasFunction={getCriteriasFn}
      searchFunction={searchFn}
      onAbort={onAbort}
      columns={columns}
      breadCrumbs={[{ text: t(ETLCodes.TitreDiplomeCertifications), route: ERoutes.diplome }]}
      addFunc={onAddItem}
      defaultCriterias={[
        {
          criteria: "Actif",
          searchMode: EBooleanSearchTypes.Equals,
          value: true
        }
      ]}
    />
  );
};
